import { render, staticRenderFns } from "./materialComponent.vue?vue&type=template&id=fe92fcd2"
import script from "./materialComponent.vue?vue&type=script&lang=js"
export * from "./materialComponent.vue?vue&type=script&lang=js"
import style0 from "./materialComponent.vue?vue&type=style&index=0&id=fe92fcd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports